import { useSearch } from '@tanstack/react-router'
import { SEARCH_PARAM_EXPLORATION_ID } from 'features/drilldown'
import { useMemo } from 'react'

export const PRESENTATION_MODE_QUERY_PARAMETER = 'presentation_mode'

/**
 * This is just a convenience method for reading strings in the search params.
 * @param initial initial value
 * @param urlParamName the search param name
 * @returns the current value
 */
export function useSearchParameter(
  initial: string | undefined,
  urlParamName: typeof SEARCH_PARAM_EXPLORATION_ID
) {
  const searchParams = useSearch({ strict: false })
  return useMemo(
    () => searchParams[urlParamName] ?? initial,
    [searchParams, urlParamName, initial]
  )
}
